/* Panda Food 2.0, product buy box.

   Ported from the prototype, but reading the real variant list Liquid renders
   and posting to the real Ajax cart. No snapshot data anywhere.               */
(function () {
  var root = document.querySelector('[data-pf2-pdp]');
  if (!root) return;

  var TIER = parseInt(root.dataset.tier, 10) || 3;
  var data = root.querySelector('[data-pf2-variants]');
  var VARIANTS = [];
  try { VARIANTS = JSON.parse(data.textContent) } catch (e) { return }
  if (!VARIANTS.length) return;

  /* A US shopper reads sizes in US sizing. Liquid works the words out once
     (snippets/pf2-size-label) and prints them on each chip as data-label, so
     the label is read from there rather than converted a second time here.
     Only the words change: the value, and every key built from it, never do. */
  function label(val, name) {
    if (!val) return val;
    var chip = [].filter.call(root.querySelectorAll('[data-label]'), function (b) {
      return b.dataset.val === val && b.dataset.opt === name;
    })[0];
    return chip ? chip.dataset.label : val;
  }

  /* Option order is the product's own. Keys are BUILT by joining values with
     "|", never split back apart, because Size values contain a "|" already. */
  var optEls = [].slice.call(root.querySelectorAll('.pf2-opt'));
  var names = optEls.map(function (el) { return el.dataset.optName });
  var chosen = {};
  optEls.forEach(function (el) {
    /* a dropdown has no .active element, so read its selected option instead.
       Missing this leaves the key half-built, every combination looks dead and
       filterColours() hides the entire colour row. */
    var drop = el.querySelector('select[data-opt]');
    if (drop) {
      var picked = drop.options[drop.selectedIndex];
      chosen[el.dataset.optName] = picked ? picked.dataset.val : '';
      return;
    }
    var on = el.querySelector('.active');
    chosen[el.dataset.optName] = on ? on.dataset.val : '';
  });

  var MAP = {};
  VARIANTS.forEach(function (v) { MAP[v.opts.join('|')] = v });

  function keyFor(over) {
    return names.map(function (n) {
      return (over && over[n] != null) ? over[n] : chosen[n];
    }).join('|');
  }
  function current() { return MAP[keyFor(null)] || null }

  /* Most combinations do not exist. Hold the option just changed and move the
     others to the nearest real variant rather than showing a dead one. */
  function repair(changed) {
    if (current()) return;
    var others = names.filter(function (n) { return n !== changed });
    var combos = [{}];
    others.forEach(function (n) {
      /* try what is already selected first, so an option the shopper did not
         touch is only moved when it genuinely has to be */
      var vals = valuesFor(n).slice().sort(function (a, b) {
        if (a === chosen[n]) return -1;
        if (b === chosen[n]) return 1;
        return 0;
      });
      var next = [];
      combos.forEach(function (c) {
        vals.forEach(function (val) {
          var d = {}; for (var k in c) d[k] = c[k]; d[n] = val; next.push(d);
        });
      });
      combos = next;
    });
    for (var i = 0; i < combos.length; i++) {
      if (MAP[keyFor(combos[i])]) {
        for (var n in combos[i]) chosen[n] = combos[i][n];
        return;
      }
    }
  }
  function valuesFor(name) {
    var el = optEls[names.indexOf(name)];
    return [].map.call(el.querySelectorAll('[data-val]'), function (b) { return b.dataset.val });
  }

  /* Colours that cannot be reached for the current pack size and foot size are
     hidden, not greyed: a swatch you cannot pick is just noise. */
  function filterColours() {
    optEls.forEach(function (el) {
      var name = el.dataset.optName;
      if (!/colour|color/i.test(name)) return;
      [].forEach.call(el.querySelectorAll('[data-val]'), function (btn) {
        var over = {}; over[name] = btn.dataset.val;
        btn.hidden = !MAP[keyFor(over)];
      });
    });
  }

  function money(pence) {
    return (function(v){var c=(window.Shopify&&Shopify.currency&&Shopify.currency.active)||'GBP';try{return new Intl.NumberFormat(c==='GBP'?'en-GB':'en-US',{style:'currency',currency:c}).format(v)}catch(e){return (c==='USD'?'$':c==='GBP'?'£':c+' ')+v.toFixed(2)}})(pence/100);
  }

  /* ---- Klarna ----

     Pay in 3 is a regulated financial promotion, so the claim cannot stand on
     its own: it needs the terms alongside it. The line already states its own
     £50 condition, and a basket can reach £50 from products priced below it, so
     the message is left visible rather than hidden on cheap products. What was
     missing was the link, added once here rather than in the section, so the
     wording stays a single theme setting.

     The URL is a setting on the element when one is provided, so Klarna's own
     approved link can replace this default without a code change. */
  (function () {
    var kl = root.querySelector('.pf2-klarna');
    if (!kl || !kl.textContent.trim()) return;
    if (kl.querySelector('a')) return;              /* already carries its terms */
    var href = kl.dataset.terms || 'https://www.klarna.com/uk/terms-and-conditions/';
    var a = document.createElement('a');
    a.href = href;
    a.target = '_blank';
    a.rel = 'noopener';
    a.textContent = 'Terms apply';
    kl.appendChild(document.createTextNode(' '));
    kl.appendChild(a);
    kl.appendChild(document.createTextNode('.'));
  })();

  function paint() {
    var v = current();
    optEls.forEach(function (el) {
      var name = el.dataset.optName;
      [].forEach.call(el.querySelectorAll('[data-val]'), function (btn) {
        var on = btn.dataset.val === chosen[name];
        btn.classList.toggle('active', on);
        btn.setAttribute('aria-checked', on ? 'true' : 'false');
      });
      var sel = root.querySelector('[data-pf2-sel="' + name + '"]');
      if (sel) sel.textContent = label(chosen[name], name);
      /* repair() can move an option the shopper did not touch, so a dropdown
         has to be told: the class toggle above does not move a <select> */
      var drop = el.querySelector('select[data-opt]');
      if (drop) {
        [].forEach.call(drop.options, function (o, i) {
          if (o.dataset.val === chosen[name]) drop.selectedIndex = i;
        });
      }
    });
    filterColours();
    if (!v) return;

    root.querySelector('[data-pf2-variant-id]').value = v.id;
    root.querySelector('[data-pf2-price]').textContent = money(v.price);

    var was = root.querySelector('[data-pf2-was]');
    var save = root.querySelector('[data-pf2-save]');
    if (v.compare > v.price) {
      was.textContent = money(v.compare); was.hidden = false;
      save.textContent = 'Save ' + Math.round((1 - v.price / v.compare) * 100) + '%';
      save.hidden = false;
    } else { was.hidden = true; save.hidden = true }

    /* per-pair price, where the product actually sells in packs */
    var pack = null;
    names.forEach(function (n) { if (/pair/i.test(n)) pack = parseInt(chosen[n], 10) });
    var unit = root.querySelector('[data-pf2-unit]');
    unit.textContent = pack ? ('for ' + pack + ' pairs · just ' + money(v.price / pack) + ' a pair') : '';

    var stock = root.querySelector('[data-pf2-stock]');
    if (stock) stock.hidden = !v.available;

    var add = root.querySelector('[data-pf2-add]');
    add.disabled = !v.available;
    paintButton();

    /* the hero follows the variant, because each has its own photograph */
    if (v.img) {
      var stage = root.querySelector('[data-pf2-stage]');
      var main = stage && stage.querySelector('img[data-i="0"]');
      if (main && main.src !== v.img) {
        main.src = v.img;
        main.alt = v.title;
        [].forEach.call(stage.querySelectorAll('img'), function (s) { s.classList.toggle('show', s === main) });
        var t0 = root.querySelector('[data-pf2-thumbs] button[data-i="0"] img');
        if (t0) t0.src = v.img;
        [].forEach.call(root.querySelectorAll('[data-pf2-thumbs] button'), function (b, i) {
          b.classList.toggle('active', i === 0);
        });
      }
    }
  }

  function qty() {
    var q = document.getElementById('pf2-qty');
    return Math.max(1, parseInt(q && q.value, 10) || 1);
  }

  /* Price on the button follows quantity, and once the quantity alone completes
     a set the note says the price shown is before the discount. */
  function paintButton() {
    var v = current(); if (!v) return;
    var n = qty();
    var lab = root.querySelector('[data-pf2-add-label]');
    if (lab) lab.textContent = v.available ? ('Add to basket · ' + money(v.price * n)) : 'Sold out';
    var note = root.querySelector('[data-pf2-atc-note]');
    var txt = root.querySelector('[data-pf2-atc-note-text]');
    if (note && txt) {
      var sets = Math.floor(n / TIER);
      note.classList.toggle('on', sets > 0 && v.available);
      if (sets > 0) txt.textContent = sets > 1
        ? (sets + ' free packs unlocked, taken off at checkout')
        : 'Buy 2 get 1 free unlocked, taken off at checkout';
    }
  }

  /* ---- wiring ---- */
  /* An option can render as a <select> instead of chips, where the values are
     too long to sit side by side. The options still carry data-opt/data-val,
     so everything above works unchanged: only the event differs, because you
     do not click an <option>, you change a <select>. */
  root.addEventListener('change', function (e) {
    var sel = e.target.closest('select[data-opt]');
    if (!sel) return;
    var picked = sel.options[sel.selectedIndex];
    if (!picked) return;
    chosen[sel.dataset.opt] = picked.dataset.val;
    repair(sel.dataset.opt);
    paint();
  });

  root.addEventListener('click', function (e) {
    /* an <option> is inside a select and is handled by change, not click */
    if (e.target.closest('select[data-opt]')) return;
    var btn = e.target.closest('[data-val]');
    if (btn) {
      chosen[btn.dataset.opt] = btn.dataset.val;
      repair(btn.dataset.opt);
      paint();
      return;
    }
    var step = e.target.closest('[data-pf2-qty]');
    if (step) {
      var q = document.getElementById('pf2-qty');
      q.value = Math.min(10, Math.max(1, qty() + parseInt(step.dataset.pf2Qty, 10)));
      paintButton();
    }
  });
  var qEl = document.getElementById('pf2-qty');
  if (qEl) ['input', 'change'].forEach(function (ev) { qEl.addEventListener(ev, paintButton) });

  /* thumbnails */
  root.addEventListener('click', function (e) {
    var t = e.target.closest('[data-pf2-thumbs] button');
    if (!t) return;
    var i = t.dataset.i;
    [].forEach.call(root.querySelectorAll('[data-pf2-thumbs] button'), function (b) { b.classList.remove('active') });
    t.classList.add('active');
    [].forEach.call(root.querySelectorAll('[data-pf2-stage] img'), function (s) {
      s.classList.toggle('show', s.dataset.i === i);
    });
  });

  /* ---- add to basket, against the real cart ---- */
  var form = document.getElementById('pf2-form');
  if (form) {
    form.addEventListener('submit', function (e) {
      var v = current();
      if (!v || !window.fetch) return;         /* no JS cart: let the form post normally */
      e.preventDefault();
      var add = root.querySelector('[data-pf2-add]');
      var lab = root.querySelector('[data-pf2-add-label]');
      var before = lab ? lab.textContent : '';
      add.disabled = true;
      if (lab) lab.textContent = 'Adding…';

      var added = false;
      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: v.id, quantity: qty() }] })
      })
      .then(function (res) {
        if (!res.ok) throw new Error('add failed');
        added = true;                       /* past this point we must never re-post */
        return fetch(window.Shopify.routes.root + 'cart.js');
      })
      .then(function (res) { return res.json() })
      .then(function (cart) {
        /* Anything that throws in here is a UI problem, not a cart problem.
           It must not reach the fallback below, or the item goes in twice. */
        try {
          paintCartCount(cart.item_count);
          document.dispatchEvent(new CustomEvent('pf2:cart:updated', { detail: cart }));
          if (window.PF2_ADDED) {
            window.PF2_ADDED({
              name: root.querySelector('h1').textContent,
              /* the popup names the pack in the shopper's own sizing too */
              variant: v.opts.map(function (o, i) {
                if (/pair/i.test(names[i] || '')) return o + (o === '1' ? ' pair' : ' pairs');
                return label(o, names[i]);
              }).join(' \u00b7 '),
              img: v.img,
              qty: qty(),
              cart: cart
            });
          }
        } catch (uiErr) {
          /* the item is in the basket, so send them to it rather than retrying */
          window.location.href = window.Shopify.routes.root + 'cart';
        }
      })
      .catch(function () {
        /* only reached when the add itself failed */
        if (!added) form.submit();
      })
      .then(function () {
        add.disabled = false;
        if (lab) lab.textContent = before;
      });
    });
  }

  function paintCartCount(n) {
    document.querySelectorAll('[data-pf2-cart-count]').forEach(function (el) {
      el.setAttribute('data-pf2-cart-count', n);
      el.classList.toggle('has-items', n > 0);
      el.setAttribute('aria-label', 'Basket, ' + n + (n === 1 ? ' item' : ' items'));
    });
  }

  /* ---- delivery countdown ----

     The cut-off is a UK business fact, so it is computed in Europe/London no
     matter where the visitor is. Reading the browser's own clock would tell a
     shopper in New York they had five more hours than they do.

     The block is three lines, set by Ryan on 12 Aug 2026:

       Order within 04:12:55 for delivery Friday 14 Aug
       Choose express delivery at checkout
       Standard delivery 3-5 days

     THE DATE THIS LINE GIVES IS THE EXPRESS DATE. That is why the line under
     it names express, and why that line is set at full reading size rather
     than as small print. A date only the paid service can hit, sitting above
     "standard 3-5 days" with nothing joining the two, is the misleading
     urgency pattern the CMA has acted on. Whatever else changes here, the
     qualifier stays adjacent and stays legible. The two lines beneath come
     from snippets/pf2-delivery.liquid, keys 'express' and 'standard'.        */
  (function () {
    var cd = root.querySelector('[data-pf2-cd]');
    if (!cd) return;
    var suf = root.querySelector('[data-pf2-cd-suf]');
    var DAYS = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    var MON = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

    var cutoff = (root.dataset.cutoff || '22:00').split(':');
    var CUT_H = parseInt(cutoff[0], 10); if (isNaN(CUT_H)) CUT_H = 22;
    var CUT_M = parseInt(cutoff[1], 10); if (isNaN(CUT_M)) CUT_M = 0;

    var fmt;
    try {
      fmt = new Intl.DateTimeFormat('en-GB', {
        timeZone: 'Europe/London', hour12: false,
        year: 'numeric', month: '2-digit', day: '2-digit',
        hour: '2-digit', minute: '2-digit', second: '2-digit'
      });
    } catch (e) { fmt = null; }

    function londonNow() {
      if (!fmt) {                      /* no Intl: fall back to the local clock */
        var d = new Date();
        return { y: d.getFullYear(), mo: d.getMonth() + 1, d: d.getDate(),
                 h: d.getHours(), mi: d.getMinutes(), s: d.getSeconds() };
      }
      var p = {};
      fmt.formatToParts(new Date()).forEach(function (x) { p[x.type] = x.value });
      /* en-GB renders midnight as 24, which would roll the day forward */
      var hour = parseInt(p.hour, 10) % 24;
      return { y: +p.year, mo: +p.month, d: +p.day, h: hour, mi: +p.minute, s: +p.second };
    }

    function two(n) { return String(n).padStart(2, '0') }

    function tick() {
      var n = londonNow();
      var nowSecs = n.h * 3600 + n.mi * 60 + n.s;
      var cutSecs = CUT_H * 3600 + CUT_M * 60;
      var left = cutSecs - nowSecs;
      var sameDay = left > 0;
      if (!sameDay) left += 86400;

      cd.textContent = [Math.floor(left / 3600), Math.floor(left % 3600 / 60), left % 60].map(two).join(':');

      /* Calendar arithmetic on the London date. UTC is only an anchor here, so
         a British Summer Time shift cannot move the day.

         Seven days a week at BOTH ends: we dispatch every day and express
         delivers every day, so neither date steps over a weekend. The previous
         version skipped Saturday and Sunday on both, which turned a genuine
         Saturday delivery into Monday and undersold every Friday and weekend
         order by up to two days, at exactly the moment a next-day promise is
         worth the most. */
      var dispatch = new Date(Date.UTC(n.y, n.mo - 1, n.d));
      if (!sameDay) dispatch.setUTCDate(dispatch.getUTCDate() + 1);
      var arrive = new Date(dispatch);
      arrive.setUTCDate(arrive.getUTCDate() + 1);

      if (suf) {
        var dy = DAYS[arrive.getUTCDay()];
        suf.innerHTML = ' for delivery <span class=d-long>' + dy + '</span><span class=d-short>' +
          dy.slice(0, 3) + '</span> ' + arrive.getUTCDate() + ' ' + MON[arrive.getUTCMonth()];
      }
    }
    tick();
    setInterval(tick, 1000);
  })();

  paint();
})();
